export const Link = {
    MuiLink: {
        defaultProps: {
            underline: "hover",
            color: "inherit"
        }
    }
};

//# sourceMappingURL=Link.js.map